export default __webpack_public_path__ + "static/media/app_store.f9a2078a.svg";